export const environment = {
  production: false,
  apiUrl: 'https://api.aoc-performance-review-dev.riotinto-dna.com/index-liv-api/api',
  cognito: {
    userPoolId: 'ca-central-1_ubYbYknHH',
    userPoolWebClientId: 'kqrhsotig4sdv16141r18k48o',
    identityPoolId: 'ca-central-1:8fafaaef-0e54-40cc-9b46-a059c6e83951',
    domain: 'index-liv-dev.auth.ca-central-1.amazoncognito.com',
    redirectSignIn: 'https://index-liv-dev.rta40.com/',
    redirectSignOut: 'https://index-liv-dev.rta40.com/',
    region: 'ca-central-1',
  },
};
